import Select from "react-select";
import "./style.css";
import { useTranslation } from "react-i18next";
import { Block, CRRender, Inline } from "../../../crRender";
import { useEffect, useState } from "react";

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#fe4d22"
      : state.isFocused
        ? "rgba(19, 84, 206, 0.1)"
        : "white",
    color: state.isSelected ? "#fff" : "#333",
    cursor: "pointer",
    transition: "all 0.3s ease",
  }),

  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "rgba(34, 93, 254, 0.1)",
    padding: "0px 10px",
    borderRadius: "12px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#345dfe",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#345dfe",
    ":hover": {
      color: "black",
    },
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 8910000565632356,
  }),
};



const MultiSelect = ({
  label,
  defaultValue,
  viewLabel = true,
  sOptions,
  setSOptions,
  isRequired = true,
  isError,
  setInputValue,
  options = [],
  isClearable = true,
  className = "col-md-6",
  isMulti = true,
  isDisabled = false,
  isRender,
  errors = false,
}) => {
  const { t } = useTranslation();
  

  return (
    <Block
      isRender={isRender}
      className={`form-group ${className}  ${isError ? "field-required" : ""}  multiSelect `}
    >
      <Block isRender={label && viewLabel} className={"col-sm-12 default-label"} >
        <label className="">{t(label)}</label>
        <Inline isRender={isRequired} className={"required"}>*</Inline>
      </Block>

      <Select
        className={`multi-select `}
        options={options}
        styles={customStyles}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        isMulti={isMulti}
        isSearchable
        onChange={(e) => setSOptions?.(e)}
        onInputChange={(e) => setInputValue?.(e)}
        value={sOptions}
        placeholder={`${t("select")} ${t(label)}`}
        isClearable={isClearable}
        isDisabled={isDisabled}
      />
      <CRRender isRender={errors }>
        <p data-outer-error={errors?.toString()} className="error-message">{isMulti ? t("required-select-field-multi") : t("required-select-field-single")}</p>
      </CRRender>
      
    </Block>
  );
};
export default MultiSelect;
